import axios from '../axios'
// 装卸地列表
export const getBaseLoadingPlacePage = (data) => {
  return axios({
    url: '/api/sys/base/getBaseLoadingPlacePage',
    method: 'post',
    data
  })
}
//保存装卸地
export const saveBaseLoadingPlace = (data) => {
  return axios({
    url: '/api/sys/base/saveBaseLoadingPlace',
    method: 'post',
    data
  })
}
// 修改装卸地
export const updateBaseLoadingPlace = (data) => {
  return axios({
    url: '/api/sys/base/updateBaseLoadingPlace',
    method: 'post',
    data
  })
}
// 删除装卸地
export const deleteBaseLoadingPlaces = (data) => {
  return axios({
    url: '/api/sys/base/deleteBaseLoadingPlaces',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/Loadplace.js